export const IconPack = {
  close_icon: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1222_37032)">
        <path
          d="M13.5 0.5L0.5 13.5"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.5 0.5L13.5 13.5"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1222_37032">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  navigate_icon: (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.12646 14.6667C8.12646 11 11.7931 9.16671 15.4598 9.16671M15.4598 9.16671L13.6265 11.9167M15.4598 9.16671L12.7098 7.33337M6.29313 20.1667H17.2931C19.3182 20.1667 20.9598 18.5251 20.9598 16.5V5.50004C20.9598 3.475 19.3182 1.83337 17.2931 1.83337H6.29313C4.26809 1.83337 2.62646 3.475 2.62646 5.50004V16.5C2.62646 18.5251 4.26809 20.1667 6.29313 20.1667Z"
        stroke="#0B63F8"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  add_icon: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1222_36454)">
        <path
          d="M7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5Z"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7 4V10"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 7H10"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1222_36454">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  delete_icon: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1222_37750)">
        <path
          d="M1 3.5H13"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.5 3.5H11.5V12.5C11.5 12.7652 11.3946 13.0196 11.2071 13.2071C11.0196 13.3946 10.7652 13.5 10.5 13.5H3.5C3.23478 13.5 2.98043 13.3946 2.79289 13.2071C2.60536 13.0196 2.5 12.7652 2.5 12.5V3.5Z"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.5 3.5V3C4.5 2.33696 4.76339 1.70107 5.23223 1.23223C5.70107 0.763392 6.33696 0.5 7 0.5C7.66304 0.5 8.29893 0.763392 8.76777 1.23223C9.23661 1.70107 9.5 2.33696 9.5 3V3.5"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.5 6.50146V10.503"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.5 6.50146V10.503"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1222_37750">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  faculty_member: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1222_30279)">
        <path
          d="M6.34961 0.5H12.652C13.1208 0.5 13.5008 0.88003 13.5008 1.34882V8.1275C13.5008 8.59629 13.1208 8.97632 12.652 8.97632H7.5"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.14854 4.00107C4.11534 4.00107 4.89908 3.21733 4.89908 2.25053C4.89908 1.28374 4.11534 0.5 3.14854 0.5C2.18175 0.5 1.39801 1.28374 1.39801 2.25053C1.39801 3.21733 2.18175 4.00107 3.14854 4.00107Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 5.52747C9 4.96001 8.53999 4.5 7.97253 4.5H3.14893C1.68597 4.5 0.500001 5.68596 0.5 7.14893V9.5H1.63525L2.01367 13.5H4.28418L5.15625 6.55493H7.97253C8.53999 6.55493 9 6.09492 9 5.52747Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1222_30279">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  publications: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1222_30297)">
        <path
          d="M7 13.5V8.25C7 7.91848 7.1317 7.60054 7.36612 7.36612C7.60054 7.1317 7.91848 7 8.25 7C8.58152 7 8.89946 7.1317 9.13388 7.36612C9.3683 7.60054 9.5 7.91848 9.5 8.25V11H11.5C12.0304 11 12.5391 11.2107 12.9142 11.5858C13.2893 11.9609 13.5 12.4696 13.5 13V13.5"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25739 3.09514C5.01089 1.72345 3.33822 0.812215 1.50977 0.508751C1.38536 0.491132 1.25862 0.500185 1.13798 0.53531C1.01733 0.570434 0.905541 0.630826 0.810029 0.712473C0.712804 0.795633 0.634748 0.898868 0.581232 1.01508C0.527715 1.13128 0.500008 1.25771 0.500016 1.38564V8.51593C0.498688 8.7349 0.578517 8.94661 0.724097 9.11018C0.869678 9.27375 1.07069 9.3776 1.28833 9.40168C2.71644 9.59538 4.05939 10.1605 5.18829 11.0293"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25781 5.8584V3.09521"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.2264 9.40168C11.444 9.3776 11.645 9.27375 11.7906 9.11018C11.9362 8.94661 12.016 8.7349 12.0147 8.51593V1.38564C12.0147 1.25771 11.987 1.13128 11.9335 1.01508C11.88 0.898868 11.8019 0.795633 11.7047 0.712473C11.6092 0.630826 11.4974 0.570434 11.3767 0.53531C11.2561 0.500185 11.1294 0.491132 11.0049 0.508751C9.1765 0.812215 7.50383 1.72345 6.25732 3.09514"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1222_30297">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
};
